import React from "react";
import { Routes, Route } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import CenterContent from "./CenterContent";
import SignIn from "../routes/Admin/SignIn";
import SignUp from "../routes/Admin/SignUp";
import ForgotPassword from "../routes/Admin/ForgotPassword";
import ResetPassword from "../routes/Admin/ResetPassword";
import VerifyEmail from "../routes/Admin/VerifyEmail";

const StartList = React.lazy(() => import("../routes/Registration/StartList"));
const TeamStartList = React.lazy(() => import("../routes/Registration/Team/TeamStartList"));
const Support = React.lazy(() => import("../routes/Support/Support"));

function RouteFeedback() {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "50%" }}>
      <CircularProgress />
    </Box>
  );
}

function SpaUnauthenticated() {
  return (
    <CenterContent drawerDisabled>
      <React.Suspense fallback={<RouteFeedback />}>
        <Routes>
          <Route path={"/signIn"} element={<SignIn />} />
          <Route path={"/signUp"} element={<SignUp />} />
          <Route path={"/forgotPassword"} element={<ForgotPassword />} />
          <Route path={"/resetPassword"} element={<ResetPassword />} />
          <Route path={"/verifyEmail"} element={<VerifyEmail />} />
          <Route path={"/register/startList"} element={<StartList />} />
          <Route path={"/team/startList"} element={<TeamStartList />} />
          <Route path={"/support"} element={<Support />} />
          <Route path={"/*"} element={<SignIn />} />
        </Routes>
      </React.Suspense>
    </CenterContent>
  );
}

export default SpaUnauthenticated;
